import { createAction } from 'redux-actions';
import { LUCINA_URL } from '../../../../utils';
import request from '../../../../utils/request';

export const start = createAction(`CREATE_SUBSCRIBER_START`);
export const success = createAction(`CREATE_SUBSCRIBER_SUCCESS`);
export const failure = createAction(`CREATE_SUBSCRIBER_FAILURE`);

const createSubscriber = (data) => async (dispatch) => {
  dispatch(start());
  const url = `${LUCINA_URL}/subscribers/`;

  try {
    const res = await request({
      method: `POST`,
      url,
      data,
      headers: {
        "X-Lucina-Domain": `starlies.com`,
      },
    });
    dispatch(success(res.data));
    return res.data;
  } catch (e) {
    let errorMessage = `Something went wrong. Please try to enter a different email or try again later.`;
    if (e.response) {
      if (e.response.data.non_field_errors && e.response.data.non_field_errors.length >= 1) {
        [errorMessage] = e.response.data.non_field_errors;
      } else if (e.response.data.email && e.response.data.email.length >= 1) {
        [errorMessage] = e.response.data.email;
      }
    }
    dispatch(failure(e));
    throw new Error(errorMessage);
  }
};

export default createSubscriber;
